import { render, staticRenderFns } from "./TextValueInput.vue?vue&type=template&id=4361c80f"
import script from "./TextValueInput.vue?vue&type=script&lang=js"
export * from "./TextValueInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports